import { useState } from "react";
import HelperString from "utils/helper-string";
import GraphqlBuilder from "utils/request/graphql/builder";
import _ from "lodash";

const useMutate = ( mutation ) => {

    const [ loading, setLoading ] = useState( false );
    const [ error, setError ] = useState( null );
    const [ data, setData ] = useState( null );

    const onCallbackStart = () => {
        setLoading( true );
        setError( null );
    }

    const onCallbackSuccess = ( callback, data ) => {

        // Get the first item from the data object
        data = _.first( Object.values( data ) );

        if( callback ) {
            callback( data );
        }

        setData( data );
    }

    const onCallbackError = ( callback, error ) => {
        if( callback ) {
            callback( data );
        }

        setError( error );
    }
    
    const onMutate = ({ variables, onSuccess, onError }) => {

        const mutationName = `mutation-${ HelperString.random( 8 ) }`;

        new GraphqlBuilder()
            .addQuery( mutationName, mutation, variables )
            .setResultPath( mutationName )
            .setOnStart( onCallbackStart )
            .setOnSuccess( onCallbackSuccess.bind( this, onSuccess ) )
            .setOnError( onCallbackError.bind( this, onError ) )
            .setOnFinally( () => {
                setLoading( false );
            })
            .execute();
    }

    return [ onMutate, { loading, error, data } ];
}

export default useMutate;